import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { findDOMNode } from "react-dom";

import { asDragSource } from "../../components/dragAndDrop/DraggableComponent";
import ColorDot from "../../components/interface/ColorDot";
import Icon from "../../components/interface/Icon";
import Identifier from "../../components/interface/Identifier";
import { withScreenContext } from "../../components/screen/ScreenContext";
import { ENTITY_LIST_VIEW } from "../../constants/identifiers";
import { PropTypeShapes } from "../../types";
import { getModifierKeysForEvent } from "../../utils/getModifierKeys";

const dragCallbacks = {
  beginDrag: _props => {
    // TODO: Do we want to set isDragging or similar...?
  },
  canDrag: props => {
    return !props.screenContext || props.screenContext.isEditMode;
  },

  getDragSourceParams: props => {
    return {
      itemId: props.itemId,
      itemType: props.typeData.id,
      sourceView: props.viewId,
      sourceViewType: ENTITY_LIST_VIEW
    };
  },

  getPreviewElement: props => renderItemPreview(props)
};

const renderItemPreview = itemProps => {
  const cloneProps = _.clone(itemProps);
  cloneProps.selected = false;
  cloneProps.relativeLeft = 0;
  cloneProps.relativeTop = 0;
  cloneProps.onClick = null;
  cloneProps.onSuperClick = null;
  return renderItem(cloneProps);
};

const renderItemWithoutAvatar = (useProps, onClick, onDoubleClick) => {
  const style = {
    opacity: useProps.isDragging ? 0 : 1,
    width: `${useProps.width}px`
  };
  return (
    <div
      ref={useProps.forwardedRef}
      className={`searchResultItem withoutAvatar ${useProps.selected ? "selected" : ""}`}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <ColorDot color={useProps.color} />
      <div className="searchResultContentBlock">
        <span>{useProps.label}</span>
        <Identifier isAvatar={false} label={useProps.displayId} color="iconMid" />
      </div>
    </div>
  );
};

const renderItemWithAvatar = (useProps, onClick, onDoubleClick) => {
  const style = {
    opacity: useProps.isDragging ? 0 : 1,
    width: `${useProps.width}px`
  };
  return (
    <div
      ref={useProps.forwardedRef}
      className={`searchResultItem withAvatar ${useProps.selected ? "selected" : ""}`}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <Icon icon={useProps.typeData.icon} color={useProps.typeData.color} />
      <span>{useProps.label}</span>
      <div className="identifierDiv">
        <Identifier isAvatar={true} label={useProps.initials} color={useProps.color} />
      </div>
    </div>
  );
};

const renderItem = (useProps, onClick, onDoubleClick) => {
  return useProps.initials
    ? renderItemWithAvatar(useProps, onClick, onDoubleClick)
    : renderItemWithoutAvatar(useProps, onClick, onDoubleClick);
};

class SearchResultItem extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      disableDrag: false
    };
    this.onClick = this.onClick.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
  }

  componentDidMount() {
    this._domNode = findDOMNode(this);
    if (this.props.onReportDimensions) {
      const rect = this._domNode.getBoundingClientRect();
      this.props.onReportDimensions(this.props.itemId, rect);
    }
  }

  componentDidUpdate() {
    if (this.props.onReportDimensions) {
      const rect = this._domNode.getBoundingClientRect();
      this.props.onReportDimensions(this.props.itemId, rect);
    }
  }

  onClick(e) {
    this.props.onClick(this.props.itemId, getModifierKeysForEvent(e));
  }

  onDoubleClick(e) {
    if (this.props.onDoubleClick) {
      this.props.onDoubleClick(this.props.itemId, getModifierKeysForEvent(e));
    }
  }

  render() {
    return renderItem(this.props, this.onClick, this.onDoubleClick);
  }
}

SearchResultItem.propTypes = {
  viewId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  selected: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  typeData: PropTypeShapes.itemType.isRequired,
  initials: PropTypes.string,
  displayId: PropTypes.string,
  identifierSize: PropTypeShapes.size.isRequired,
  label: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  onReportDimensions: PropTypes.func,

  // From asDragSource
  isDragging: PropTypes.bool,
  dragIsFromSameSource: PropTypes.bool,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = asDragSource(SearchResultItem, ENTITY_LIST_VIEW, dragCallbacks);
//#!if iOS === true
// exportedView = withScreenContext(exportedView);
//#!endif

export default exportedView;
